import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API } from '../utils/api';
import { LogoFull } from './Logo';

var getPasswordStrength = function(pw) {
  if (!pw) return { level: 0, label: '', color: '#e5e7eb' };
  var score = 0;
  if (pw.length >= 8) score++;
  if (/[a-zA-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pw)) score++;
  if (pw.length >= 12) score++;
  if (score <= 2) return { level: 1, label: '약함', color: '#ef4444' };
  if (score <= 3) return { level: 2, label: '보통', color: '#f59e0b' };
  return { level: 3, label: '강함', color: '#16a34a' };
};

function ResetPassword() {
  var navigate = useNavigate();
  var [searchParams] = useSearchParams();
  var token = searchParams.get('token') || '';
  var [password, setPassword] = useState('');
  var [passwordConfirm, setPasswordConfirm] = useState('');
  var [showPw, setShowPw] = useState(false);
  var [loading, setLoading] = useState(false);
  var [error, setError] = useState('');
  var [success, setSuccess] = useState('');

  var pwStrength = getPasswordStrength(password);

  var handleSubmit = function() {
    setError('');
    if (!token) { setError('유효하지 않은 링크입니다.'); return; }
    if (!password) { setError('새 비밀번호를 입력해주세요.'); return; }
    if (password !== passwordConfirm) { setError('비밀번호가 일치하지 않습니다.'); return; }
    if (password.length < 8) { setError('비밀번호는 8자 이상이어야 합니다.'); return; }

    setLoading(true);
    fetch(API + '/auth/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: token, newPassword: password }),
    })
    .then(function(r) { return r.json(); })
    .then(function(d) {
      if (d.success) {
        setSuccess(d.message);
        setTimeout(function() { navigate('/login'); }, 2000);
      } else {
        setError(d.error || '비밀번호 변경에 실패했습니다.');
      }
      setLoading(false);
    })
    .catch(function() { setError('서버 연결 실패'); setLoading(false); });
  };

  var is = { width: '100%', height: 48, paddingLeft: 44, paddingRight: 48, border: '1.5px solid #e2e8f0', borderRadius: 12, fontSize: 15, outline: 'none', transition: 'border-color 0.2s', backgroundColor: '#f8fafc', fontFamily: "'Pretendard',sans-serif", boxSizing: 'border-box' };
  var iconS = { position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(180deg,#f8fafc 0%,#eff6ff 100%)', fontFamily: "'Pretendard',sans-serif", padding: 20, position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: -200, right: -200, width: 600, height: 600, background: '#dbeafe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -200, left: -200, width: 500, height: 500, background: '#e0f2fe', borderRadius: '50%', filter: 'blur(100px)', opacity: 0.4, pointerEvents: 'none' }} />
      <div style={{ width: '100%', maxWidth: 420, position: 'relative', zIndex: 10 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <LogoFull iconSize={40} fontSize={28} />
          <p style={{ color: '#94a3b8', fontSize: 14, fontWeight: 500, letterSpacing: '0.05em' }}>USED CAR EXPORT SYSTEM</p>
        </div>
        <div style={{ backgroundColor: 'white', borderRadius: 20, padding: '40px 36px', boxShadow: '0 4px 40px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' }}>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>비밀번호 재설정</h2>
          <p style={{ fontSize: 14, color: '#94a3b8', marginBottom: 32 }}>새로운 비밀번호를 입력해주세요</p>

          {error && <div style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
            <span style={{ color: '#dc2626', fontSize: 14, fontWeight: 500 }}>{error}</span>
          </div>}

          {success && <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ color: '#16a34a', fontSize: 14, fontWeight: 500 }}>{success}</span>
          </div>}

          {!success && <div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 8 }}>새 비밀번호</label>
              <div style={{ position: 'relative' }}>
                <div style={iconS}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg></div>
                <input type={showPw ? 'text' : 'password'} value={password} onChange={function(e) { setPassword(e.target.value); }} onKeyDown={function(e) { if (e.key === 'Enter') handleSubmit(); }} placeholder="8자 이상 (영문+숫자+특수문자)" autoFocus style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
                <button onClick={function() { setShowPw(!showPw); }} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#94a3b8', padding: 4 }}>{showPw ? '\uD83D\uDE48' : '\uD83D\uDC41'}</button>
              </div>
              {password && <div style={{ marginTop: 8 }}>
                <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
                  {[1, 2, 3].map(function(i) {
                    return <div key={i} style={{ flex: 1, height: 4, borderRadius: 2, background: i <= pwStrength.level ? pwStrength.color : '#e5e7eb', transition: 'background 0.3s' }} />;
                  })}
                </div>
                <span style={{ fontSize: 12, color: pwStrength.color, fontWeight: 600 }}>{pwStrength.label}</span>
              </div>}
            </div>

            <div style={{ marginBottom: 28 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 8 }}>비밀번호 확인</label>
              <div style={{ position: 'relative' }}>
                <div style={iconS}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg></div>
                <input type={showPw ? 'text' : 'password'} value={passwordConfirm} onChange={function(e) { setPasswordConfirm(e.target.value); }} onKeyDown={function(e) { if (e.key === 'Enter') handleSubmit(); }} placeholder="비밀번호를 다시 입력하세요" style={is} onFocus={function(e) { e.target.style.borderColor = '#3b82f6'; }} onBlur={function(e) { e.target.style.borderColor = '#e2e8f0'; }} />
              </div>
              {passwordConfirm && password !== passwordConfirm && <p style={{ fontSize: 12, color: '#ef4444', marginTop: 6 }}>비밀번호가 일치하지 않습니다.</p>}
              {passwordConfirm && password === passwordConfirm && password.length >= 8 && <p style={{ fontSize: 12, color: '#16a34a', marginTop: 6 }}>비밀번호가 일치합니다.</p>}
            </div>

            <button onClick={handleSubmit} disabled={loading || !password || password !== passwordConfirm} style={{ width: '100%', height: 52, backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: loading ? 'default' : 'pointer', fontFamily: "'Pretendard',sans-serif", boxShadow: '0 4px 12px rgba(15,23,42,0.2)', opacity: loading || !password || password !== passwordConfirm ? 0.5 : 1 }}>{loading ? '변경 중...' : '비밀번호 변경'}</button>
          </div>}

          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <a href="/login" style={{ color: '#64748b', fontSize: 13, textDecoration: 'none' }}>로그인으로 돌아가기</a>
          </div>
        </div>
        <div style={{ textAlign: 'center', marginTop: 48 }}><p style={{ color: '#cbd5e1', fontSize: 12 }}>&copy; 2026 AUTODEX. All rights reserved.</p></div>
      </div>
    </div>
  );
}

export default ResetPassword;
